import ReactDOM from 'react-dom'
import { useState } from 'react'
import { store } from '~/Store'
import { macroTreeNode } from 'Pages/Explore/LeftPanel/ProjectQueries/TreeNodeFactory/Macros'
import { Button, Modal, message } from 'antd'
import { Clipboard } from 'react-feather'
import CreateMacro from './CreateMacro'
import WeaverService from 'Services/WeaverService'
import { CreateMacroDataProvider, useCreateMacroData, defaultState } from './CreateMacroDataProvider'
import { reset } from './CreateMacroDataProvider/actions'
import { save, load } from './helpers'
import './index.scss'

export default showCreateMacro = (nodeId) ->

  div = document.createElement('div')
  document.body.append(div)

  destroy = ->
    unmountResult = ReactDOM.unmountComponentAtNode(div)
    if unmountResult and div.parentNode
      div.parentNode.removeChild(div)

  renderedTitle = (
    <div
      className="title-container"
      data-testid={"create-new-macro"}
    >
      <div className='title'>
          <Clipboard className="macroIcon"/>
          <span
            className='title-text'
            data-testid="macro-help-title"
          >
            { if nodeId? then 'Edit Form' else 'Create new Form' }
          </span>
      </div>
    </div>
  )

  initialState = (await load(nodeId))

  CreateMacroModal = ({ destroy }) ->

    [visible, setVisible] = useState(true)
    [current, setCurrent] = useState(0)
    [state, dispatch] = useCreateMacroData()

    handleCreate = ->
      try
        macro = await save(nodeId, state)
        await WeaverService.updateMacros()
        dispatch(reset())
        destroy()
      catch e
        console.log e
        message.error("There was an issue creating the form. Please make sure you entered the form data correctly.")

    <Modal
      maskClosable={false}
      centered={true}
      width={Math.max(800, window.innerWidth * 0.8)}
      className="create-macro-container"
      visible={visible}
      destroyOnClose={true}
      footer={
        <>
          <Button type='link' disabled={!current} onClick={ -> setCurrent(0)}>Previous</Button>
          <Button type='link' disabled={current} onClick={ -> setCurrent(1)}>Next</Button>
          <Button
            type="primary"
            disabled={!current}
            onClick={ -> handleCreate()}
          >Save</Button>
          <Button onClick={destroy}>Cancel</Button>
        </>
      }
      onCancel={-> setVisible(false)}
      afterClose={destroy}
      title={renderedTitle}
    >
      <div className="content">
        <CreateMacro
          current={current}
          setCurrent={setCurrent}
          destroy={destroy}
        />
      </div>
    </Modal>

  ReactDOM.render(
    <CreateMacroDataProvider initialState={initialState}>
      <CreateMacroModal destroy={destroy} />
    </CreateMacroDataProvider>
  , div)
